import { Grid, Tab, Radio, Stack} from "@mui/material";
import React from "react";
import { register } from "../../serviceWorker";
import OutlinedCard from "../Cards/Card";
import { StyledTabs } from "./Dialog.styles";
import { TabPanel, TabContent } from "./TabPanel";

import { planPrice, planPriceDesc } from "../Dialog/PlanFeatures";

const DialogPlan = (props: any) => {
  const { subscriptionOptions, featuresData, featurePrice, featurePriceDesc, tabValue, register, setTabValue } =
    props;

  const handleTabChange = ( newValue: number) => {
    props.handleTabs( newValue);
  };
  
  return (

      <Grid container  spacing={2} sx={{width:"100%",pl:2,py:"0px"}}>
        {subscriptionOptions.map(({ label, value }: any, index: any) => (
          // <Tab
          //   key={index}
          //   disableFocusRipple={true}
          //   icon={
          //     // <Radio
          //     //   {...register("subscription")}
          //     //   key={index}
          //     //   checked={props.tabValue === index}
          //     //   value={label}
          //     //   name="plans"
          //     // />

          //   }
          //   label={label}
          // />
      <Grid item xs={4}  onClick={()=>handleTabChange(index)} 
      sx={{justifyContent:"center",alignItems:"center"}}
      >
          <OutlinedCard          
          {...register("subscription")}
          checked={props.tabValue === index}
          sx={{ height: '100%' }}
          key={index}
          tableValue={tabValue}
          value={label}
          featuresData={featuresData[index]}
          featurePrice={planPrice[index]}
          featurePriceDesc={planPriceDesc[index]}
          name="Plans"
          border={tabValue===index ? "2px solid  rgb(24, 144, 255) ":"2px solid transparent"}
          />
        </Grid>

        ))}
         </Grid>
      //    <StyledTabs value={tabValue} onChange={handleTabChange}>
      //    {subscriptionOptions.map((({label, value}, index) => (
      //      <Tab 
      //        key={index}
      //        disableFocusRipple={true}
      //        icon={<Radio {...register('subscription')} key={index} checked={tabValue === index} value={label} name="plans" />} label={label} />
      //    )))}
      //  </StyledTabs>
       
  
  );
};

export default DialogPlan;
